import React from 'react';
import PropTypes from 'prop-types';
import './SwapIcon.css';

/**
 * Generic swap icon for trade functionality
 * @param {Object} props
 * @param {number} props.size - Icon size in pixels
 * @param {boolean} props.isActive - Whether the icon should be displayed in active state
 * @param {string} props.className - Additional CSS classes
 */
const SwapIcon = ({ 
  size = 24,
  isActive = false,
  className = ''
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      version="1.1" 
      viewBox="0 0 1200 1200" 
      xmlns="http://www.w3.org/2000/svg"
      className={`swap-icon ${isActive ? 'swap-icon--active' : ''} ${className}`}
    >
      <path d="m439.5 422.45h404.55l-119.21 119.2c-7.0312 7.0195-7.0312 18.422 0 25.453 3.5156 3.5156 8.125 5.2695 12.73 5.2695 4.6094 0 9.2148-1.7539 12.73-5.2695l149.91-149.9c0.82812-0.82812 1.5859-1.7539 2.2422-2.7344 0.16797-0.23828 0.25391-0.50391 0.39453-0.74219 0.46875-0.75781 0.91016-1.5234 1.2617-2.3516 0.14453-0.35938 0.21484-0.75781 0.33594-1.1172 0.25391-0.74219 0.52734-1.4648 0.68359-2.2422 0.25391-1.1641 0.35938-2.3516 0.35938-3.5508s-0.12109-2.3984-0.35938-3.5508c-0.15625-0.78125-0.42188-1.5-0.68359-2.2422-0.13281-0.37109-0.20312-0.75781-0.33594-1.1172-0.34766-0.82812-0.79297-1.5977-1.2617-2.3516-0.14453-0.23828-0.23828-0.50391-0.39453-0.74219-0.66016-0.98438-1.4023-1.8945-2.2422-2.7344l-149.9-149.91c-7.0312-7.0312-18.422-7.0312-25.453 0-7.0312 7.0195-7.0312 18.434 0 25.453l119.18 119.18h-404.55c-113.04 0-205.01 91.969-205.01 205.01 0 9.9492 8.0625 18 18 18s18-8.0508 18-18c0-93.191 75.816-169.01 169.01-169.01zm508.01 168.09c-9.9375 0-18 8.0508-18 18 0 93.191-75.816 169.01-169.01 169.01h-404.55l119.21-119.2c7.0312-7.0195 7.0312-18.422 0-25.453s-18.422-7.0312-25.453 0l-149.93 149.91c-0.82813 0.82812-1.5859 1.7539-2.2422 2.7344-0.17969 0.25391-0.27734 0.53906-0.43359 0.79297-0.44531 0.74219-0.88672 1.4883-1.2344 2.293-0.15625 0.37109-0.22656 0.76953-0.34766 1.1641-0.25391 0.71875-0.51562 1.4414-0.67188 2.1953-0.23828 1.1641-0.35938 2.3516-0.35938 3.5625 0 1.2109 0.13281 2.3984 0.35938 3.5625 0.15625 0.75781 0.42188 1.4766 0.67188 2.1953 0.13281 0.38281 0.20312 0.78125 0.34766 1.1641 0.33594 0.80469 0.78125 1.5469 1.2344 2.293 0.15625 0.25391 0.25391 0.53906 0.43359 0.79297 0.66016 0.98438 1.4023 1.8945 2.2422 2.7344l149.89 149.89c3.5156 3.5156 8.125 5.2695 12.73 5.2695 4.6094 0 9.2148-1.7539 12.73-5.2695 7.0312-7.0195 7.0312-18.434 0-25.453l-119.18-119.18h404.55c113.04 0 205.01-91.969 205.01-205.01 0.003906-9.9414-8.0586-17.996-17.996-17.996z"/>
    </svg>
  );
};

SwapIcon.propTypes = {
  size: PropTypes.number,
  isActive: PropTypes.bool,
  className: PropTypes.string
};

export default SwapIcon;